import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import Cookies from "js-cookie";
import axios from "axios";
import { getAllMasterCurrencyIdAndName } from "../../../Redux/action/MasterAction";
import { generateCode } from "../../../helper/autoGenId";
import { adminMainUrl } from "../../../Config";

const JobClosingCostRevenueFinalization = () => {
  const token = Cookies.get("token");
  const user_id = Cookies.get("flexichain_user_id");

  const {
    MasterBranchName,
    MasterBranchNameError,

    loadingLedgerAccountIdAndPartyName,
    LedgerAccountIdAndPartyName,
    LedgerAccountIdAndPartyNameError,

    loadingMasterCurrencyIdAndName,
    MasterCurrencyIdAndName,
    MasterCurrencyIdAndNameError,
  } = useSelector((state) => state?.MasterReducer);

  const [formData, setFormData] = useState({
    shipment_no: "",
    customer: "",
    origin: "",
    destination: "",
    shipment_date: "",
    weight: "",
    service_type: "",

    // Revenue Fields
    freight_charges: "",
    fuel_surcharge: "",
    security_fee: "",
    handling: "",
    documentation: "",
    insurance: "",
    other_charges: "",
    total_revenue: "",
    revenue_currency: "",
    revenue_exchange_rate: "",
    base_revenue: "",

    // Cost Fields
    airline_charges: "",
    agent_commission: "",
    handling_cost: "",
    documentation_cost: "",
    local_charges: "",
    customs_cost: "",
    trucking: "",
    other_cost: "",
    total_cost: "",
    cost_currency: "",
    cost_exchange_rate: "0",
    base_cost: "",

    // Profitability
    gross_profit: "",
    profit_margin: "",
    profit_per_kg: "",
    closing_date: "",
    created_by: "",
    closing_remarks: "",
  });

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [selectedCurrency, setSelectedCurrency] = useState("");

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const location = useLocation();
  const urlString = window.location.href;
  const url = new URL(urlString);
  const path = url.pathname.slice(1);
  const searchParams = url.search;
  const q = path + searchParams;
  const queryParams = new URLSearchParams(location.search);

  const onValueChange = (e) => {
    const { name, value, type, checked } = e.target;
    let finalValue = value;
    if (type === "number") {
      const numericValue = Number(value);
      if (numericValue <= 0) {
        finalValue = "";
      } else {
        finalValue = numericValue;
      }
    }
    setFormData((prev) => ({
      ...prev,
      [name]: finalValue,
    }));
  };

  const CancelForm = () => {
    setFormData({
      shipment_no: "",
      customer: "",
      origin: "",
      destination: "",
      shipment_date: "",
      weight: "",
      service_type: "",

      // Revenue Fields
      freight_charges: "",
      fuel_surcharge: "",
      security_fee: "",
      handling: "",
      documentation: "",
      insurance: "",
      other_charges: "",
      total_revenue: "",
      revenue_currency: "",
      revenue_exchange_rate: "",
      base_revenue: "",

      // Cost Fields
      airline_charges: "",
      agent_commission: "",
      handling_cost: "",
      documentation_cost: "",
      local_charges: "",
      customs_cost: "",
      trucking: "",
      other_cost: "",
      total_cost: "",
      cost_currency: "",
      cost_exchange_rate: "0",
      base_cost: "",

      // Profitability
      gross_profit: "",
      profit_margin: "",
      profit_per_kg: "",
      closing_date: "",
      created_by: "",
      closing_remarks: "",
    });
  };

  const validation = () => {
    const errors = [];
    if (!formData.customer) {
      errors.push("customer is required");
    }
    if (!formData.destination) {
      errors.push("destination is required");
    }
    if (!formData.shipment_date) {
      errors.push("shipment date is required");
    }
    if (!formData.weight) {
      errors.push("weight is required");
    }
    if (!formData.service_type) {
      errors.push("service type is required");
    }
    if (!formData.freight_charges) {
      errors.push("freight charges is required");
    }
    if (!formData.fuel_surcharge) {
      errors.push("fuel surcharge is required");
    }

    if (!formData.security_fee) {
      errors.push("security fee is required");
    }

    if (!formData.handling) {
      errors.push("handling charges is required");
    }

    if (!formData.documentation) {
      errors.push("documentation charges is required");
    }

    if (!formData.insurance) {
      errors.push("insurance charges is required");
    }

    if (!formData.revenue_exchange_rate) {
      errors.push("exchange rate is required");
    }

    //--------------cost-------
    if (!formData.airline_charges) {
      errors.push("airline charges is required");
    }

    if (!formData.agent_commission) {
      errors.push("agent commission is required");
    }

    if (!formData.handling_cost) {
      errors.push("handling cost is required");
    }

    if (!formData.documentation_cost) {
      errors.push("documentation cost is required");
    }

    if (!formData.local_charges) {
      errors.push("local charges is required");
    }

    if (!formData.customs_cost) {
      errors.push("customs cost is required");
    }

    if (!formData.trucking) {
      errors.push("trucking cost is required");
    }

    if (!formData.cost_exchange_rate) {
      errors.push("cost exchange rate is required");
    }
    if (!formData.closing_date) {
      errors.push("closing date is required");
    }

    if (errors.length > 0) {
      errors.forEach((item) => toast.error(item));
      return false;
    }
    return true;
  };

  const createCostAndRevenue = async () => {
    if (!validation()) return;
    // console.log("fromdata", formData);
    try {
      setIsSubmitting(true);

      const response = await fetch(
        `${adminMainUrl}/api/account/cost-and-revenue-finalization`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "auth-token": Cookies.get("token"),
            user_id: Cookies.get("flexichain_user_id"),
          },
          body: JSON.stringify(formData),
        }
      );

      const data = await response.json();

      if (response.ok) {
        toast.success(
          data?.msg || "cost-and-revenue-finalization created successfully"
        );
        CancelForm()
      } else {
        toast.error(
          data?.msg || "Failed to create cost-and-revenue-finalization"
        );
        console.error("Server error:", data);
      }
    } catch (error) {
      console.error("Network error:", error);
      toast.error("Something went wrong while saving");
    } finally {
      setIsSubmitting(false);
    }
  };

  useEffect(() => {
    //Revenue Details

    const freightCharges = Number(formData.freight_charges);
    const fuelSurcharge = Number(formData.fuel_surcharge);
    const securityFee = Number(formData.security_fee);
    const handlingFee = Number(formData.handling);
    const documentationFee = Number(formData.documentation);
    const insuranceFee = Number(formData.insurance);
    const otherCharges = Number(formData.other_charges);
    const totalRevenue =
      freightCharges +
      fuelSurcharge +
      securityFee +
      handlingFee +
      documentationFee +
      insuranceFee +
      otherCharges;

    //cost
    const airlineCharges = Number(formData.airline_charges);
    const agentCommission = Number(formData.agent_commission);
    const handlingCost = Number(formData.handling_cost);
    const documentationCost = Number(formData.documentation_cost);
    const localCharges = Number(formData.local_charges);
    const customsCost = Number(formData.customs_cost);
    const truckingCost = Number(formData.trucking);
    const otherCost = Number(formData.other_cost);
    const totalCost =
      airlineCharges +
      agentCommission +
      handlingCost +
      documentationCost +
      localCharges +
      customsCost +
      truckingCost +
      otherCost;

    const baseRevenue = totalRevenue * formData.revenue_exchange_rate;
    const baseCost = totalCost * formData.cost_exchange_rate;

    setFormData((pre) => ({
      ...pre,
      total_revenue: totalRevenue || 0,
      total_cost: totalCost || 0,

      base_revenue: baseRevenue || 0,
      base_cost: baseCost || 0,
    }));
  }, [
    formData.freight_charges,
    formData.fuel_surcharge,
    formData.security_fee,
    formData.handling,
    formData.documentation,
    formData.insurance,
    formData.other_charges,

    formData.airline_charges,
    formData.agent_commission,
    formData.handling_cost,
    formData.documentation_cost,
    formData.local_charges,
    formData.customs_cost,
    formData.customs_cost,
    formData.trucking,
    formData.other_cost,
  ]);

  //revenue_currency change
  useEffect(() => {
    const testRev = MasterCurrencyIdAndName.find(
      (item) => item.id == formData.revenue_currency
    );

    setFormData((prev) => ({
      ...prev,
      revenue_exchange_rate: testRev?.exchange_rate || 0,
    }));
  }, [formData.revenue_currency]);

  //cost_currency change
  useEffect(() => {
    const testRev = MasterCurrencyIdAndName.find(
      (item) => item.id == formData.cost_currency
    );

    setFormData((prev) => ({
      ...prev,
      cost_exchange_rate: testRev?.exchange_rate || 0,
    }));
  }, [formData.cost_currency]);

  //calculate baseRevenue and baseCost
  useEffect(() => {
    const totalRevenue = Number(formData.total_revenue) || 0;
    const totalCost = Number(formData.total_cost) || 0;

    const revenueRate = Number(formData.revenue_exchange_rate) || 0;
    const costRate = Number(formData.cost_exchange_rate) || 0;

    const baseRevenue = Number(totalRevenue * revenueRate) || 0;
    const baseCost = Number(totalCost * costRate) || 0;

    setFormData((prev) => ({
      ...prev,
      base_revenue: baseRevenue.toFixed(2),
      base_cost: baseCost.toFixed(2),
    }));
  }, [
    formData.total_revenue,
    formData.total_cost,
    formData.revenue_exchange_rate,
    formData.cost_exchange_rate,
  ]);

  //calculate  gross_profit, profit_margin, profit_per_kg
  useEffect(() => {
    const baseRevenue = Number(formData.base_revenue) || 0;
    const baseCost = Number(formData.base_cost) || 0;
    const weight = Number(formData.weight) || 0;

    const grossProfit = Number(baseRevenue - baseCost);

    const profitMargin =
      baseRevenue > 0 ? (grossProfit / baseRevenue) * 100 : 0;

    const profitPerKg = weight > 0 ? grossProfit / weight : 0;

    setFormData((prev) => ({
      ...prev,
      gross_profit: grossProfit.toFixed(2),
      profit_margin: profitMargin.toFixed(2),
      profit_per_kg: profitPerKg.toFixed(2),
    }));
    if (grossProfit < 0) {
      toast.warning("This shipment is running at a loss");
    }
  }, [formData.base_revenue, formData.base_cost, formData.weight]);

  useEffect(() => {
    if (token && user_id) {
      dispatch(getAllMasterCurrencyIdAndName(token, user_id));
    } else {
      toast.error("Please login to continue.");
      navigate(`/login?burl=${encodeURIComponent(q)}`);
    }
  }, [token, user_id, location.search]);

  return (
    <>
      <style>
        {`
          .label-muted { font-weight: 500; color: #6c757d; }
          .input-card {
            background:#f8f9fa;
            border-radius:8px;
            padding:8px 12px;
          }
        `}
      </style>

      <div className="card p-4">
        <h5 className="fw-semibold mb-3">
          Shipment Cost & Revenue Finalization
        </h5>

        {/* Shipment Details */}
        <div className="row g-3">
          {/* Shipment No */}
          <div className="col-md-3">
            <label className="label-muted">
              Shipment Number <span className="text-danger">*</span>
            </label>
            <input
              className="form-control bg-light"
              name="shipment_no"
              value={formData.shipment_no}
              onChange={onValueChange}
            />
          </div>

          {/* Customer */}
          <div className="col-md-3">
            <label className="label-muted">
              Customer <span className="text-danger">*</span>
            </label>
            <input
              className="form-control bg-light"
              name="customer"
              value={formData.customer}
              onChange={onValueChange}
            />
          </div>

          {/* Origin */}
          <div className="col-md-3">
            <label className="label-muted">
              Origin <span className="text-danger">*</span>
            </label>
            <input
              className="form-control bg-light"
              name="origin"
              value={formData.origin}
              onChange={onValueChange}
            />
          </div>

          {/* Destination */}
          <div className="col-md-3">
            <label className="label-muted">
              Destination <span className="text-danger">*</span>
            </label>
            <input
              className="form-control bg-light"
              name="destination"
              value={formData.destination}
              onChange={onValueChange}
            />
          </div>

          {/* Shipment Date */}
          <div className="col-md-3">
            <label className="label-muted">
              Shipment Date <span className="text-danger">*</span>
            </label>
            <input
              type="date"
              className="form-control bg-light"
              name="shipment_date"
              value={formData.shipment_date}
              onChange={onValueChange}
            />
          </div>

          {/* Weight */}
          <div className="col-md-3">
            <label className="label-muted">
              Weight (KG) <span className="text-danger">*</span>
            </label>
            <input
              type="number"
              className="form-control bg-light"
              name="weight"
              value={formData.weight}
              onChange={onValueChange}
            />
          </div>

          {/* Service Type */}
          <div className="col-md-3">
            <label className="label-muted">
              Service Type <span className="text-danger">*</span>
            </label>
            <select
              className="form-select bg-light"
              name="service_type"
              value={formData.service_type}
              onChange={onValueChange}
            >
              <option value="">Select Service</option>
              <option value="Air Freight">Air Freight</option>
              <option value="Sea Freigh">Sea Freight</option>
              <option value="Road Transport">Road Transport</option>
              <option value="Rail Transport">Rail Transport</option>
              <option value="Express">Express</option>
              <option value="Standard">Standard</option>
            </select>
          </div>
        </div>

        {/* ================= Revenue + Cost Section ================= */}
        <div className="row mt-4 g-4">
          {/* Revenue Details */}
          <div className="col-md-6">
            <h6 className="fw-semibold">Revenue Details</h6>

            <div className="row g-3 mt-2">
              <div className="col-12 col-sm-6">
                <label className="label-muted">
                  Freight Charge <span className="text-danger">*</span>
                </label>
                <input
                  type="number"
                  className="form-control bg-light"
                  name="freight_charges"
                  onChange={onValueChange}
                  value={formData.freight_charges}
                  placeholder="0"
                />
              </div>

              <div className="col-12 col-sm-6">
                <label className="label-muted">
                  Fuel Surcharge <span className="text-danger">*</span>
                </label>
                <input
                  type="number"
                  className="form-control bg-light"
                  name="fuel_surcharge"
                  onChange={onValueChange}
                  value={formData.fuel_surcharge}
                  placeholder="0"
                />
              </div>

              <div className="col-12 col-sm-6">
                <label className="label-muted">
                  Security Fee <span className="text-danger">*</span>
                </label>
                <input
                  type="number"
                  className="form-control bg-light"
                  name="security_fee"
                  onChange={onValueChange}
                  value={formData.security_fee}
                  placeholder="0"
                />
              </div>

              <div className="col-12 col-sm-6">
                <label className="label-muted">
                  Handling <span className="text-danger">*</span>
                </label>
                <input
                  type="number"
                  className="form-control bg-light"
                  name="handling"
                  onChange={onValueChange}
                  value={formData.handling}
                  placeholder="0"
                />
              </div>

              <div className="col-12 col-sm-6">
                <label className="label-muted">
                  Documentation Charge <span className="text-danger">*</span>
                </label>
                <input
                  type="number"
                  className="form-control bg-light"
                  name="documentation"
                  onChange={onValueChange}
                  value={formData.documentation}
                  placeholder="0"
                />
              </div>

              <div className="col-12 col-sm-6">
                <label className="label-muted">
                  Insurance Charge <span className="text-danger">*</span>
                </label>
                <input
                  type="number"
                  className="form-control bg-light"
                  name="insurance"
                  onChange={onValueChange}
                  value={formData.insurance}
                  placeholder="0"
                />
              </div>

              <div className="col-12 col-sm-6">
                <label className="label-muted">Other Charge</label>
                <input
                  type="number"
                  className="form-control bg-light"
                  name="other_charges"
                  onChange={onValueChange}
                  value={formData.other_charges}
                  placeholder="0"
                />
              </div>

              {/* Total Revenue */}
              <div className="col-12">
                <label className="label-muted">Total Revenue</label>
                <input
                  className="form-control bg-light border-primary"
                  name="total_revenue"
                  onChange={onValueChange}
                  value={formData.total_revenue}
                  disabled={true}
                />
              </div>

              {/* Currency */}
              <div className="col-12 col-sm-6">
                <label className="label-muted">Currency</label>
                <select
                  className="form-select bg-light"
                  name="revenue_currency"
                  value={formData.revenue_currency}
                  onChange={onValueChange}
                >
                  <option value="">
                    Select currency <span className="text-danger">*</span>{" "}
                  </option>
                  {MasterCurrencyIdAndName.map((item, i) => (
                    <option value={item.id}>{item.currency_name}</option>
                  ))}
                </select>
              </div>

              {/* Exchange Rate */}
              <div className="col-12 col-sm-6">
                <label className="label-muted">
                  Exchange Rate <span className="text-danger">*</span>
                </label>
                <input
                  type="number"
                  className="form-control bg-light"
                  name="revenue_exchange_rate"
                  value={formData.revenue_exchange_rate}
                  onChange={onValueChange}
                  placeholder="0.00"
                />
              </div>

              {/* base_revenue */}
              <div className="col-12">
                <label className="label-muted">Base Revenue</label>
                <input
                  className="form-control bg-light "
                  name="base_revenue"
                  onChange={onValueChange}
                  value={formData.base_revenue}
                  disabled={true}
                />
              </div>
            </div>
          </div>

          {/* Cost Details */}
          <div className="col-md-6">
            <h6 className="fw-semibold">Cost Details</h6>

            <div className="row g-3 mt-2">
              <div className="col-12 col-sm-6">
                <label className="label-muted">
                  Airline Charges <span className="text-danger">*</span>
                </label>
                <input
                  type="number"
                  className="form-control bg-light"
                  name="airline_charges"
                  onChange={onValueChange}
                  value={formData.airline_charges}
                  placeholder="0"
                />
              </div>

              <div className="col-12 col-sm-6">
                <label className="label-muted">
                  Agent Commission <span className="text-danger">*</span>
                </label>
                <input
                  type="number"
                  className="form-control bg-light"
                  name="agent_commission"
                  onChange={onValueChange}
                  value={formData.agent_commission}
                  placeholder="0"
                />
              </div>

              <div className="col-12 col-sm-6">
                <label className="label-muted">
                  Handling Cost <span className="text-danger">*</span>
                </label>
                <input
                  type="number"
                  className="form-control bg-light"
                  name="handling_cost"
                  onChange={onValueChange}
                  value={formData.handling_cost}
                  placeholder="0"
                />
              </div>

              <div className="col-12 col-sm-6">
                <label className="label-muted">
                  Documentation Cost <span className="text-danger">*</span>
                </label>
                <input
                  type="number"
                  className="form-control bg-light"
                  name="documentation_cost"
                  onChange={onValueChange}
                  value={formData.documentation_cost}
                  placeholder="0"
                />
              </div>

              <div className="col-12 col-sm-6">
                <label className="label-muted">
                  Local Charges <span className="text-danger">*</span>
                </label>
                <input
                  type="number"
                  className="form-control bg-light"
                  name="local_charges"
                  onChange={onValueChange}
                  value={formData.local_charges}
                  placeholder="0"
                />
              </div>

              <div className="col-12 col-sm-6">
                <label className="label-muted">
                  Customs Cost <span className="text-danger">*</span>
                </label>
                <input
                  type="number"
                  className="form-control bg-light"
                  name="customs_cost"
                  onChange={onValueChange}
                  value={formData.customs_cost}
                  placeholder="0"
                />
              </div>

              <div className="col-12 col-sm-6">
                <label className="label-muted">
                  Trucking <span className="text-danger">*</span>
                </label>
                <input
                  type="number"
                  className="form-control bg-light"
                  name="trucking"
                  onChange={onValueChange}
                  value={formData.trucking}
                  placeholder="0"
                />
              </div>

              <div className="col-12 col-sm-6">
                <label className="label-muted">
                  Other Cost <span className="text-danger">*</span>
                </label>
                <input
                  type="number"
                  className="form-control bg-light"
                  name="other_cost"
                  onChange={onValueChange}
                  value={formData.other_cost}
                  placeholder="0"
                />
              </div>

              {/* Total Cost */}
              <div className="col-12">
                <label className="label-muted">Total Cost</label>
                <input
                  className="form-control bg-light border-warning"
                  name="total_cost"
                  onChange={onValueChange}
                  value={formData.total_cost}
                  disabled={true}
                />
              </div>

              {/* Cost Currency */}
              <div className="col-12 col-sm-6">
                <label className="label-muted">
                  Cost Currency <span className="text-danger">*</span>
                </label>
                <select
                  className="form-select bg-light"
                  name="cost_currency"
                  value={formData.cost_currency}
                  onChange={onValueChange}
                >
                  <option value="">Select currency </option>
                  {MasterCurrencyIdAndName.map((item, i) => (
                    <option value={item.id}>{item.currency_name}</option>
                  ))}
                </select>
              </div>

              {/* Exchange Rate */}
              <div className="col-12 col-sm-6">
                <label className="label-muted">
                  Exchange Rate <span className="text-danger">*</span>
                </label>
                <input
                  type="number"
                  className="form-control bg-light"
                  name="cost_exchange_rate"
                  value={formData.cost_exchange_rate}
                  onChange={onValueChange}
                  placeholder="0.00"
                />
              </div>

              {/* base_cost */}
              <div className="col-12">
                <label className="label-muted">Base Cost</label>
                <input
                  className="form-control bg-light"
                  name="base_cost"
                  onChange={onValueChange}
                  value={formData.base_cost}
                  disabled={true}
                />
              </div>
            </div>
          </div>
        </div>

        {/* =================== Profitability =================== */}
        <div className="card mt-4 p-4">
          <h6 className="fw-semibold">Profitability Analysis</h6>

          <div className="row g-3 mt-2">
            <div className="col-md-3">
              <label className="label-muted">Gross Profit</label>
              <div className="input-card bg-success-subtle text-success fw-bold">
                ₹ {formData.gross_profit}
              </div>
            </div>

            <div className="col-md-3">
              <label className="label-muted">Profit Margin (%)</label>
              <div className="input-card bg-primary-subtle text-primary fw-bold">
                {formData.profit_margin} %
              </div>
            </div>

            <div className="col-md-3">
              <label className="label-muted">Profit per KG</label>
              <div className="input-card bg-info-subtle text-info fw-bold">
                ₹ {formData.profit_per_kg}
              </div>
            </div>

            <div className="col-md-3">
              <label className="label-muted">
                Closing Date <span className="text-danger">*</span>
              </label>
              <input
                type="date"
                className="form-control bg-light"
                name="closing_date"
                onChange={onValueChange}
              />
            </div>

            <div className="col-md-4">
              <label className="label-muted">
                Created By <span className="text-danger">*</span>
              </label>
              <input
                type="text"
                className="form-control bg-light"
                name="created_by"
                onChange={onValueChange}
                value={formData.created_by}
              />
            </div>

            <div className="col-md-8">
              <label className="label-muted">Closing Remarks</label>
              <input
                type="text"
                className="form-control bg-light"
                name="closing_remarks"
                onChange={onValueChange}
                value={formData.closing_remarks}
              />
            </div>
          </div>
        </div>

        {/* Buttons */}
        <div className="d-flex gap-2 mt-4 flex-wrap">
          <button
            onClick={() => createCostAndRevenue()}
            className="btn btn-primary px-4"
          >
            <i className="fas fa-save me-1"></i>
            Save
          </button>
          <button className="btn btn-light px-4">Finalize</button>
          <button className="btn btn-light px-4">Recalculate</button>
          <button className="btn btn-light px-4">Print Summary</button>
          <button onClick={() => CancelForm()} className="btn btn-light px-4">
            <i className="fas fa-undo me-1"></i>
            Cancel
          </button>
        </div>
      </div>
    </>
  );
};

export default JobClosingCostRevenueFinalization;
